<template>

  <v-dialog class="dialog" v-model="dialog" max-width="420">
    <v-card>
      <v-card-title class="headline">Are you sure you want to delete?</v-card-title>
      <v-card-text>This action is irreversible.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed="depressed" @click="dialog = false">Cancel</v-btn>
        <v-btn depressed="depressed" @click="confirmed()">Delete</v-btn>
      </v-card-actions>
    </v-card>
    <v-icon class="mr-2" title="Delete" slot="activator">mdi-delete</v-icon>
  </v-dialog>

</template>

<script>

export default {
  name: 'ProxyDeleteButton',
  data: () => ({
    dialog: null
  }),
  methods: {
    confirmed () {
      this.$emit('click')
      this.dialog = false
    }
  }
}

</script>

<style lang="scss" scoped>

.dialog {
  margin-top: -7px;
}

</style>



// WEBPACK FOOTER //
// src/components/common/ProxyDeleteButton.vue